import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Baseurl } from "../../config/BaseUrl";

import { FaMinus, FaPlus } from "react-icons/fa";
import { SetLoginModalOpen } from "../../redux/authentication/AuthenticationSlice";
import { setProductBySubcat } from "../../redux/subCategory/subCategorySlice";
import SelectCarDetails from "../SelectCarDetails";
import {
  SetSelectedCategory,
  addtoCart,
  clearCart,
  decrementCart,
  getCartTotal,
} from "../../redux/cart/CartSlice";
import { Delete } from "@mui/icons-material";
import {
  setChoosedCategory,
  setClickedCategory,
  setSelectedSaloon,
} from "../../redux/saloon/SaloonSlice";
// Add salon cart imports
import {
  addtoSalonHomeCart,
  decrementSalonHomeCart,
  getSalonHomeCartTotal,
  removefromSalonHomeCart,
} from "../../redux/cart/HomeSalon";

const SearchCatSearch = () => {
  const {
    clickedSaloon,
    clickedCategory,
    choosedCategory,
    categoryChoosedBySearch,
  } = useSelector((store) => store.saloon);
  
  // Use salon home cart for salon services
  const { salonHomeCartItems } = useSelector((store) => store.SalonHomeCart);
  const { CartItems, selectedCategory } = useSelector((store) => store.Cart);
  const { isAuth } = useSelector((store) => store.Authentication);

  const [selectedCat, setSelectedCat] = useState("");
  const [catBySaloon, setCatBySaloon] = useState([]);
  const [servicesByCat, setServicesByCat] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const targetDivRef = useRef(null);

  // Fetch categories based on selected saloon
  useEffect(() => {
    if (clickedSaloon) {
      const getCategories = async () => {
        try {
          setLoading(true);
          const url = `${Baseurl}/api/v1/saloonCategory/categorybysupercatid/${clickedSaloon}`;
          const resp = await axios.get(url);
          
          if (resp.data.success) {
            const categories = resp.data.category || [];
            setCatBySaloon(categories);
            
            // Set default category if none selected
            if (categories.length > 0) {
              let selectedCategory;
              
              if (categoryChoosedBySearch) {
                selectedCategory = categories.find(
                  (cat) => cat._id === categoryChoosedBySearch
                );
              }
              
              if (!selectedCategory) {
                selectedCategory = categories[0];
              }
              
              setSelectedCat(selectedCategory);
              dispatch(setChoosedCategory(selectedCategory));
              dispatch(setClickedCategory(selectedCategory._id));
            }
          }
        } catch (error) {
          console.error("Error fetching categories:", error);
        } finally {
          setLoading(false);
        }
      };
      getCategories();
    }
  }, [clickedSaloon, categoryChoosedBySearch]);

  // Fetch services based on selected category
  useEffect(() => {
    if (clickedCategory) {
      const getServices = async () => {
        try {
          setLoading(true);
          const url = `${Baseurl}/api/v1/saloonServices/servicesbycatid/${clickedCategory}`;
          const resp = await axios.get(url);
          
          if (resp.data.success) {
            let services = resp.data.services || [];
            
            // Add cartQuantity to each service based on current cart
            const servicesWithCartQty = services.map(service => {
              const cartItem = salonHomeCartItems.find(
                item => item.ProductId === service._id
              );
              return {
                ...service,
                cartQuantity: cartItem ? cartItem.Qty : 0
              };
            });
            
            setServicesByCat(servicesWithCartQty);
          }
        } catch (error) {
          console.error("Error fetching services:", error);
        } finally {
          setLoading(false);
        }
      };
      getServices();
    }
  }, [clickedCategory, salonHomeCartItems]);

  const handleSaloonChange = async (subcat) => {
    if (!subcat) return;
    
    setSelectedCat(subcat);
    dispatch(setClickedCategory(subcat._id));
    dispatch(setChoosedCategory(subcat));
  };

  const addToCartPress = (product, index) => {
    if (!product || !selectedCat) return;
    
    const formData = {
      salonId: product.superCategoryId || clickedSaloon,
      ProductId: product._id,
      ProductName: product.name,
      Brand: selectedCat.name || "Salon Service",
      CatName: selectedCat.name,
      CatId: selectedCat._id,
      Services: product.services || [],
      Duration: product.duration || "30 min",
      ImgUrl: product.image || "",
      Mrp: product.mrp || 0,
      Price: product.price || 0,
      Qty: 1,
      TotalAmount: (product.price || 0) * 1,
      TotalPrice: (product.price || 0) * 1,
      TotalMrp: (product.mrp || 0) * 1,
      Discount: (product.mrp || 0) * 1 - (product.price || 0) * 1,
      productCostPrice: product.price || 0,
      for: "Saloon",
      address: selectedCat.address || "",
      area: selectedCat.area || "",
      phone: selectedCat.phone || "",
    };

    // Update local state
    const updatedServices = [...servicesByCat];
    if (updatedServices[index]) {
      updatedServices[index].cartQuantity = (updatedServices[index].cartQuantity || 0) + 1;
    }
    setServicesByCat(updatedServices);

    // Dispatch salon home cart action
    dispatch(addtoSalonHomeCart(formData));
    dispatch(getSalonHomeCartTotal());
  };

  const decrementCartPress = (product, index) => {
    if (!product) return;
    
    // Update local state
    const updatedServices = [...servicesByCat];
    if (updatedServices[index] && updatedServices[index].cartQuantity > 0) {
      updatedServices[index].cartQuantity -= 1;
    }
    setServicesByCat(updatedServices);

    // Dispatch salon home cart decrement action
    dispatch(decrementSalonHomeCart({
      ProductId: product._id,
      Price: product.price || 0,
      Mrp: product.mrp || 0
    }));
    dispatch(getSalonHomeCartTotal());
  };

  const handleCheckout = () => {
    if (!isAuth) {
      dispatch(SetLoginModalOpen(true));
    } else {
      navigate("/cart"); // Use different route for salon cart
    }
  };

  if (loading) {
    return (
      <div style={{ marginTop: "60px", padding: "20px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: "60px" }}>
        <div className="_3iw1l">
          <div
            className="p-1"
            style={{
              position: "sticky",
              top: "6%",
              zIndex: "5",
              backgroundColor: "#fff",
            }}
          >
            <div className="_3Mcoq" style={{ gridColumn: "1 / 2" }}>
              <div className="_1PI3k" style={{ maxWidth: "unset" }}>
                <div
                  className="_2GkAY OBszR _1bZNH"
                  id="services-type-container"
                  ref={targetDivRef}
                >
                  {catBySaloon && catBySaloon.length > 0 ? (
                    catBySaloon.map((subcat, index) => (
                      <div
                        key={subcat._id || index}
                        onClick={() => handleSaloonChange(subcat)}
                        style={{ cursor: "pointer", display: "inline-block" }}
                      >
                        <div
                          className={
                            selectedCat?._id === subcat._id
                              ? "_2GkAY _3O2l6 _37qa5 _17y17 _85XiK"
                              : "_2GkAY _3O2l6 _37qa5 _17y17"
                          }
                        >
                          <img
                            loading="lazy"
                            src={subcat.desktopImage}
                            alt={subcat.name}
                            className={
                              selectedCat?._id === subcat._id
                                ? "_1z4vM _3BshJ"
                                : "_1z4vM"
                            }
                          />
                          <div
                            className={
                              selectedCat?._id === subcat._id
                                ? "_1qpUY d5ttk"
                                : "_1qpUY"
                            }
                            style={{ fontWeight: "bold" }}
                          >
                            {subcat.name}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: "10px", textAlign: "center" }}>
                      No categories found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <SelectCarDetails />

          <div style={{ backgroundColor: "#FFFFFF" }}>
            <div className="_1t_e2" style={{ maxWidth: "unset" }}>
              <div>
                <div className="_13CKU">
                  <div className="_5Ze1h" />
                  <div className="_1ZZEG">
                    <div>
                      {servicesByCat && servicesByCat.length > 0 ? (
                        servicesByCat.map((product, index) => (
                          <div className="_1sR0p" key={product._id || index}>
                            {/* Badges */}
                            {product.bestSeller && (
                              <div className="_1vXOy">
                                <div>BESTSELLER</div>
                              </div>
                            )}
                            {product.mustTry && (
                              <div className="_1vXOy">
                                <div>Must Try</div>
                              </div>
                            )}
                            {product.outOfStock && (
                              <div className="_1vXOy">
                                <div>Out of Stock</div>
                              </div>
                            )}
                            {product.inDemand && (
                              <div className="_1vXOy">
                                <div>In Demand</div>
                              </div>
                            )}
                            {product.hotDeal && (
                              <div className="_1vXOy">
                                <div>Hot Deal</div>
                              </div>
                            )}

                            <div className="_34vKl">
                              <div className="_33hIJ">
                                <div className="_2RxcB">
                                  <img
                                    loading="lazy"
                                    className="_2OGze"
                                    src={product.image}
                                    alt={product.name}
                                    onError={(e) => {
                                      e.target.src = "https://via.placeholder.com/100";
                                    }}
                                  />
                                </div>
                                <div className="_3Bc52">
                                  <div className="_2Rhyt" style={{ marginBottom: 15 }}>
                                    <div className="_1JPIu">
                                      <h2
                                        style={{ margin: 0 }}
                                        className="_1d-DS text-start d-flex justify-content-start"
                                      >
                                        {product.ItemName || product.name}
                                      </h2>
                                    </div>
                                    {product.duration && (
                                      <div className="_1CkVx">
                                        <img
                                          loading="lazy"
                                          src="https://gomechprod.blob.core.windows.net/websiteasset/New%20Website/components/Services/ServicesListDesktop/76D2D1C8-A85C-4C56-A53D-DE23B9C19F76.svg"
                                          className="_1QJKc"
                                          alt="Time Taken during service"
                                        />
                                        <div className="_2qAPV">
                                          {product.duration}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    style={{ marginLeft: 0, marginBottom: 20 }}
                                    className="_1qUuq"
                                  >
                                    {product.description || product.name}
                                  </div>
                                  {product.services && product.services.length > 0 && (
                                    <div className="_2UPbx">
                                      {product.services.map((indService, i) => (
                                        <div className="_3qzZ9" key={i}>
                                          <img
                                            loading="lazy"
                                            src="https://gomechprod.blob.core.windows.net/websiteasset/New%20Website/components/Services/B267FE43-1120-4815-B81E-6C2AE1EFC4C1.svg"
                                            className="vZyEa"
                                            alt="Included"
                                          />
                                          <div className="_1qUuq">
                                            {indService.service || indService}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <div style={{ marginLeft: 0, marginTop: 20 }} className="_1qUuq">
                                    {product.mrp && product.mrp > product.price && (
                                      <span style={{ marginRight: "15px" }}>
                                        <s style={{ color: "red" }}>
                                          ₹ {product.mrp}
                                        </s>
                                      </span>
                                    )}
                                    <span style={{ fontWeight: "bold" }}>
                                      ₹ {product.price || product.mrp || "N/A"}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Cart Controls */}
                              {product.cartQuantity > 0 ? (
                                <div className="_2sr-o" style={{ cursor: "pointer" }}>
                                  <div className="I6yQz" />
                                  <div
                                    className="_59ZXH"
                                    style={{
                                      width: "20%",
                                      display: "flex",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      onClick={() => decrementCartPress(product, index)}
                                    >
                                      <FaMinus style={{ cursor: "pointer" }} />
                                    </span>
                                    <span className="">
                                      {product.cartQuantity}
                                    </span>
                                    <span
                                      onClick={() => addToCartPress(product, index)}
                                    >
                                      <FaPlus style={{ cursor: "pointer" }} />
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className="_2sr-o"
                                  onClick={() => addToCartPress(product, index)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="I6yQz" />
                                  <div className="_59ZXH">+ ADD TO CART</div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "20px", textAlign: "center" }}>
                          No services found for this category
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchCatSearch;